import {DataStorage} from '@convincely/utils/lib/services/storage.js';

export const inputRaw = new DataStorage();
